import { BACKEND_HOST } from "../../api";

// 상대경로 이미지 src 를 백엔드 호스트 기준 절대 URL 로 정규화
export const toPackageImageUrl = (src) => {
  if (typeof src !== "string") return "";
  const trimmedSrc = src.trim();
  if (!trimmedSrc) return "";
  if (/^(https?:)?\/\//.test(trimmedSrc) || trimmedSrc.startsWith("data:") || trimmedSrc.startsWith("blob:")) {
    return trimmedSrc;
  }
  return trimmedSrc.startsWith("/") ? `${BACKEND_HOST}${trimmedSrc}` : trimmedSrc;
};

// 다양한 형태(문자열/객체)의 이미지 항목에서 사용 가능한 src 를 추출
export const getPackageImageSrc = (imageItem) => {
  if (!imageItem) return "";
  if (typeof imageItem === "string") return toPackageImageUrl(imageItem);

  const imageCandidates = [
    imageItem.src,
    imageItem.image,
    imageItem.url,
    imageItem.image_url,
    imageItem.thumbnail,
    imageItem.thumbnail_url,
    imageItem.file,
    imageItem.path,
  ];

  for (const candidate of imageCandidates) {
    const candidateSrc = typeof candidate === "object"
      ? getPackageImageSrc(candidate)
      : toPackageImageUrl(candidate);
    if (candidateSrc) return candidateSrc;
  }

  return "";
};
